import moment from "moment";
import {
	STANDARD_APP_DATE_FORMAT,
	STANDARD_APP_DATE_TIME_FORMAT,
} from "../constants/constants";

export const convertDate = (targetDate: string) => {
	let date = new Date(targetDate);

	date = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
	console.log(`${date.getFullYear()}-0${date.getMonth()}-${date.getDate()}`);
	console.log(date);

	return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

export const formatDateTimeWithLocale = (date: string | null) => {
	if (date) {
		return moment.utc(date).format(STANDARD_APP_DATE_TIME_FORMAT);
	} else {
		return "--";
	}
};

export const formatDate = (date: string | null) => {
	if (!date) return "";
	return moment(date).format(STANDARD_APP_DATE_FORMAT);
};

export const formatDate2 = (date: string | null) => {
	if (!date) return "";
	return moment(date).format("YYYY-MM-DD");
};

export const formatDateWithTime = (date: string | null | undefined) => {
	if (!date) return "";
	return moment.utc(date).format(STANDARD_APP_DATE_TIME_FORMAT);
};
